/*  ========================================================================
    # JavaScript - Admin
    ========================================================================  */

function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('../../theme/Components/', true, /\/admin\.js$/));
